export async function getCart(): Promise<{
  items?: Array<{
    key?: string;
    quantity?: number;
    final_line_price?: unknown;
    original_line_price?: unknown;
    line_level_discount_allocations?: Array<{ amount?: unknown } | null>;
    variant_id?: unknown;
    properties?: Record<string, unknown>;
  }>;
}> {
  const response = await fetch(window.Shopify!.routes.root + 'cart.js');
  return response.json();
}

// `sections`: optional section ids to have Shopify render in the response (same contract
// as Dawn's own cart calls). Lets the caller repaint DOM the theme's cartUpdate
// subscribers don't cover, e.g. the header cart bubble.
export async function updateCart(
  updates: Record<string, number>,
  sections?: string[],
): Promise<{ item_count?: number; sections?: Record<string, string | null> } | null> {
  if (!Object.keys(updates).length) return null;

  const body: { updates: Record<string, number>; sections?: string[]; sections_url?: string } = {
    updates,
  };
  if (sections?.length) {
    body.sections = sections;
    body.sections_url = window.location.pathname;
  }

  const response = await fetch(window.Shopify!.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error('Failed to update cart');
  }

  return response.json();
}
